const CHUNK_LOAD_RELOAD_ATTEMPTED_KEY = "drillpoint:chunk-load-reload-attempted";

const CHUNK_LOAD_ERROR_PATTERNS = [
  /importing a module script failed/i,
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /loading chunk [\w-]+ failed/i,
  /chunkloaderror/i,
];

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return `${error.name} ${error.message}`;
  if (typeof error === "string") return error;
  return "";
};

export const isRecoverableChunkLoadError = (error: unknown): boolean => {
  const errorMessage = getErrorMessage(error);
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(errorMessage));
};

export const shouldReloadForChunkLoadError = (
  error: unknown,
  storage: Pick<Storage, "getItem" | "setItem"> = window.sessionStorage
): boolean => {
  if (!isRecoverableChunkLoadError(error)) return false;
  if (storage.getItem(CHUNK_LOAD_RELOAD_ATTEMPTED_KEY) === "true") return false;

  storage.setItem(CHUNK_LOAD_RELOAD_ATTEMPTED_KEY, "true");
  return true;
};

export const clearChunkLoadReloadAttempt = (
  storage: Pick<Storage, "removeItem"> = window.sessionStorage
) => {
  storage.removeItem(CHUNK_LOAD_RELOAD_ATTEMPTED_KEY);
};
